/* This component is header component which is reusable 
   for all components 
   Created by: Nikhil Gaykhe
*/

import React, { useEffect, useState } from 'react';
import SideNav from 'HELPDESK/Header/SideNavigation/SideNav';
import 'HELPDESK/Header/header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from "HELPDESK/CommonResources/SuccessModal/SuccessModal";
import Axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Bell, History, Grip } from 'lucide-react';
import UserProfilePanel from 'HELPDESK/CommonResources/UserProfilePanel/UserProfilePanel';
import BookMarkModal from 'HELPDESK/CommonResources/BookmarkModal/BookMarkModal';
import UserActivityPanel from 'HELPDESK/CommonResources/UserActivityPanel/UserActivityPanel';
import NotificationPanel from 'HELPDESK/CommonResources/NotificationPanel/NotificationPanel';
import { toast } from 'react-toastify';

const Header = (props) => {
    const pointsData = config.pointsInfo;

    // VARIABLES FOR OVERDUE MESSAGE
    const [overdueCondition, setOverdueCondition] = useState('');
    const [overdueMessage, setOverdueMessage] = useState('');
    const [stepNumber, setStepNumber] = useState('');
    const [alertModal, setAlertModal] = useState(false);
    const [dueDate, setDueDate] = useState("");
    const [dateAfterSevenDays, setDateAfterSevenDays] = useState("");
    const [paymentAcceptanceObject, setPaymentAcceptanceObject] = useState({});
    const [acceptanceSequenceIdArray, setAcceptanceSequenceIdArray] = useState([]);
    const [clientSubscriptionId, setClientSubscriptionId] = useState('');
    const [installmentId, setInstallmentId] = useState('');
    const [acceptanceCount, setAcceptanceCount] = useState('');
    const [showModuleDetails, setShowModuleDetails] = useState(false);
    const [daysCount, setDaysCount] = useState("seven");
    const [acceptingExtension, setAcceptingExtension] = useState(false);

    // VARIABLES TO VIEW MODULE LIST POPOVER
    const [showFilter, setShowFilter] = useState(false);
    const [moduleListArray, setModuleListArray] = useState([]);
    const [searchModule, setSearchModule] = useState('');
    const [checkedValue, setCheckedValue] = useState([]);
    const [temporaryModuleListArray, setTemporaryModuleListArray] = useState([]);

    // VARIABLES TO VIEW SUCCESS MODAL
    const [successModal, setSuccessModal] = useState(false);
    const [successModalType, setSuccessModalType] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [subscriptionWaring, setSubscriptionWaring] = useState('');
    const [userAcceptedHTML, setUserAcceptedHTML] = useState('');
    const [instituteIdArray, setInstituteIdArray] = useState([]);

    const [moduleListModal, setModuleListModal] = useState(false);
    const [userInfoModal, setUserInfoModal] = useState(false);
    const [ActivityLogModal, setActivityLogModal] = useState(false);
    const [notificationModal, setNotificationModal] = useState(false);
    const [openBookMarkModal, setOpenBookmarkModal] = useState(false);
    const [unReadMessageCount, setUnReadMessageCount] = useState(0);
    const [unReadUpdateReadMessageCount, setUnReadMessageUpdateCount] = useState(0);
    const [isNotificationModalUpdate, setIsNotificationModalUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    // VARIABLE TO DEFINE DISPATCH
    const dispatch = useDispatch(); 

    const imageExtensions = ['jpeg', 'jpg', 'png'];

    useEffect(() => {
        document.getElementById("mySidenav").style.width = "0";
        if(instituteIdArray?.length == 0)
        {
            getGetInstructorAssignedInstituteList();
        }

        //API CALL TO GET MODULE LIST ARRAY
        Axios.get(`${config.RootUrl}/faculty/summary/moduleNavigation.json`).then(res => {
            setModuleListArray(res.data);
            setTemporaryModuleListArray(res.data);
        });
        
    }, []);
    useEffect(() => {
        // console.log("instituteIdArray",instituteIdArray)
        if (instituteIdArray?.length > 0) {
            // METHOD CALLED TO GET OVERDUE
            apiCallToGetOverdueDetails();
        }
    }, [instituteIdArray]);

    const getGetInstructorAssignedInstituteList = async () => {
        try {
         
            const requestData = { facultyId: config.faculty_id };

            const jsonResponse = await HelpdeskApiCall.makeApiCall(
                'GetInstructorAssignedInstituteList',
                requestData,
                '/api/management/management.php'
            );

            if (jsonResponse.expired) {
                setTimeout(getGetInstructorAssignedInstituteList, 1000);
                return;
            }

            if (jsonResponse.success) {
                const apiResult = jsonResponse.APIResult.data;
                const assignedIIDArray = Object.keys(apiResult);
                setInstituteIdArray(assignedIIDArray);
                
            }
        } catch (error) {
            console.error('Error in getGetInstructorAssignedInstituteList:', error);
        }
    };
    // API CALL METHOD TO GET OVERDUE DETAILS
    const apiCallToGetOverdueDetails = async () => {
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "iidArray":instituteIdArray
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskPendingInstallmentDueDateMessageForCentralFlow',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetOverdueDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let alertModal = false;
                let stepNumber = jsonResponse.APIResult.stepNumber;
                let subscriptionWaringTemp = jsonResponse.APIResult.subscriptionWaring;
                let userAcceptedHTMLTemp = jsonResponse.APIResult.userAcceptedHTML;
                          
                if(!(stepNumber == 0 && apiResult.acceptanceSequenceIdArray.length == 0)) {
                    document.getElementById("routeSetup").style.paddingTop = "78px";
                }else {
                    document.getElementById("routeSetup").style.paddingTop = "48px";
                }

                if(stepNumber > 3) {
                    alertModal = true;
                }

                if((stepNumber == 4 && apiResult.acceptanceSequenceIdArray.length == 1) || (stepNumber == 5 && apiResult.acceptanceSequenceIdArray.length == 2)  || (stepNumber == 6 && apiResult.acceptanceSequenceIdArray.length == 3)) {
                    alertModal= false;
                }
                
                let acceptanceCount = apiResult.acceptanceSequenceIdArray.length + 1;
                setSubscriptionWaring(subscriptionWaringTemp);
                setUserAcceptedHTML(userAcceptedHTMLTemp)
                setOverdueCondition(apiResult.status);
                setOverdueMessage(apiResult.message);
                setDueDate(apiResult.dueDate);
                setDateAfterSevenDays(apiResult.dateAfterSevenDays);
                setPaymentAcceptanceObject(apiResult.paymentAcceptanceObj);
                setAcceptanceSequenceIdArray(apiResult.acceptanceSequenceIdArray);
                setClientSubscriptionId(apiResult.clientSubscriptionId);
                setDaysCount(apiResult.daysCount);
                setInstallmentId(apiResult.installmentId);
                setStepNumber(stepNumber);
                setAlertModal(alertModal);
                setAcceptanceCount(acceptanceCount);
            }
        }
    }

    useEffect(() => {
        apiCallToGetWebNotification();
        apiCallToGetUpdateDetails();
    }, [notificationModal, isNotificationModalUpdate]);

    //  API CALL TO GET NOTIFICATION
    const apiCallToGetWebNotification = async () => {
        setIsLoading(true);
        let formData = {
            iid: config.institute_id,
            // userRole: config.instructorRole == "instructor" || config.instructorRole == "employee" || config.instructorRole == "teaching" || config.instructorRole == "nonteaching" ? "instructor" : "learner",
            userRole: config.instructorInfo.account == "faculty" || config.instructorInfo.account == "instructor" || config.instructorInfo.account == "employee" || config.instructorInfo.account == "teaching" || config.instructorInfo.account == "nonteaching" ? "instructor" : "learner",
            userId: config.faculty_id,
            offset: 1,
            limit: 10,
            // iidArray: AdminAccessReducer.iidArray.iidArray
        };
        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            "webNotificationGetNotification",
            formData,
            '/api/webNotification/webNotification.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetWebNotification();
            }, 1000);
        } else {
            if (jsonResponse.success) {


                let unReadMessageCount = Number(jsonResponse.APIResult.unReadMessageCount);

                setUnReadMessageCount(unReadMessageCount);

                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        }


    }

    //  API CALL TO GET UPDATES
    const apiCallToGetUpdateDetails = async () => {
        const requestData = {
            userId: config.faculty_id,
            iid: config.institute_id,


        };
        try {
            const jsonResponse = await HelpdeskApiCall.makeApiCall(
                'pmTool_getSummaryNotificationCount',
                requestData,
                "/api/projectManagement/Queries/pmTool_DocSEMDashBoard.php"
            );
            if (jsonResponse.expired) {
                setTimeout(() => {
                    apiCallToGetUpdateDetails();
                }, 1000);
            } else {
                if (jsonResponse.success) {

                    let updateReadUnCount = Number(jsonResponse.APIResult.unreadNotificationCount);


                    setUnReadMessageUpdateCount(updateReadUnCount);




                } else {
                    toast.error("Something went wrong While getting Announcements")
                }
            }
        } catch (error) {
            toast.error('Something went wrong While getting Announcements:', error);
        }
    };

    //METHOD TO ACCEPT SUBSCRIPTION EXTENSION
    const apiCallToAcceptExtension = async () => {
        setAcceptingExtension(true);
        
        let acceptanceCount = acceptanceSequenceIdArray.length + 1;

        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "clientSubscriptionId": clientSubscriptionId,
            "installmentId": installmentId,
            "acceptanceCount": acceptanceCount,
            "dueDate": dueDate,
            "dateAfterSevenDays": dateAfterSevenDays,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'AddHelpDeskInstallmentAcceptanceDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToAcceptExtension();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                setAcceptingExtension(false);

                if(apiResult.status == "success") {
                    setAlertModal(false);
                    setAcceptanceCount(acceptanceCount);
                    setShowModuleDetails(true);
                    setSuccessModal(true);
                    setSuccessModalType('success');
                    setSuccessMessage(apiResult.message);
                }
            }
        }
    }

    // METHOD TO RETURN SUCCESS MODAL FOR TRANSITION / TRANSFER QUERY
    const returnSubscriptionAlertModal = () => {
        return(
            <div className={alertModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">                        
                        <div className="modal-body SubscriptionAlertModal-body">
                            <div style={{display:"flex",flexDirection:"column-reverse",alignItems:"flex-end"}} >
                                <a className="" style={{ cursor: 'pointer' }} href = {`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`} onClick={() => userSignOut()}>
                                    Log Out
                                </a>
                            </div>
                            <div className="step4">
                                <div className="col-md-10">
                                    {
                                        ReactHtmlParser(subscriptionWaring) 
                                    }
                                </div>
                                <div className="col-md-2 ">
                                    <div className="warningIconContainer">
                                    <FontAwesomeIcon
                                        className="warningicon"
                                        icon={["fas", "exclamation-triangle"]}
                                        size="lg"
                                        color="#F44336"
                                    />
                                    </div>
                                </div>
                            </div>
                            {
                                ReactHtmlParser(userAcceptedHTML) 
                            }
                            {
                                stepNumber == 3 ?
                                    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                        <button className="btn outline-button backQueryButton" style={{ textTransform: 'none', cursor: 'Pointer' }} onClick={() => setAlertModal(false)}>
                                            Close
                                        </button>
                                    </div>
                                    :
                                    (stepNumber == 4 || stepNumber == 5 || stepNumber == 6) &&
                                    <div style={{display:'flex',flexDirection:'row-reverse'}}>                                   
                                        <button className="btn btn-outline-primary waves-effect" style={{ textTransform: 'none' }} >
                                            <a href={config.RootUrl + '/modules/myworkspace/#/'} style={{textTransform: 'none',color:"#0465ac"}}>
                                                Go To Summary
                                            </a>
                                        </button>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // HANDLE FILTER BY CATEGORY
    const handleFilterByCategory = (e) => {
        let checkedValues = checkedValue;
        if (checkedValues.includes(e.target.value)) {
            checkedValues = checkedValues.filter(name => name != e.target.value);
        }else {
            checkedValues.push(e.target.value);
        }

        setCheckedValue(checkedValues);
        
        handleFilterByCategoryResponse(checkedValues);
    }

    // HANDLE FILTER BY CATEGORY RESPONSE
    const handleFilterByCategoryResponse = (checkedValues) => {
        let checkedFilterArray = [];
        
        temporaryModuleListArray.map((module_type) => {
            let isChecked = false;
            for (let i = 0; i < checkedValues.length; i++) {
                if (module_type.moduleType.includes(checkedValues[i])) {
                    isChecked = true;
                }
            }

            if (isChecked) {
                checkedFilterArray.push(module_type);
            }
        });

        if (checkedValues.length == 0) {
            setModuleListArray(temporaryModuleListArray);
        } else {
            setModuleListArray(checkedFilterArray);
        }
    }

    // METHOD TO SIGN OUT USER
    const userSignOut = () => {
        props.history.push(`${config.RootUrl}/vmlogout.php`);
    }

    if (config.institute_name === '') {
        config.institute_name = 'vmedulife';
    }

    const closeBookMark = () => {
        setOpenBookmarkModal(false);
    }

    const notificationUpdates = () => {
        setIsNotificationModalUpdate(!isNotificationModalUpdate);
    }

    //handleModalOpenClose
    const handleModalOpenClose = (modalName) => {
        if (modalName == "moduleList") {
            setModuleListModal(!moduleListModal);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);
            setOpenBookmarkModal(false);
        }

        if (modalName == "userInfo") {
            setUserInfoModal(!userInfoModal);
            setModuleListModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);
            setOpenBookmarkModal(false);

        }
        if (modalName == "notification") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(!notificationModal);
            setOpenBookmarkModal(false);

        }
        if (modalName == "userActivity") {
            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(!ActivityLogModal);
            setNotificationModal(false);
            setOpenBookmarkModal(false);


        }
        if (modalName == "bookmarkModal") {
            setOpenBookmarkModal(!openBookMarkModal);

            setModuleListModal(false);
            setUserInfoModal(false);
            setActivityLogModal(false);
            setNotificationModal(false);
        }
    }

    return (
        <>
            <div>
                <nav className="navbar navbar-expand-lg navbar-dark">
                    <div className="college-name">
                        <button className="sidenav-button btn btn-link text-white" style={{ fontSize: 16 }} type="button" onClick={() => routingMenu.expandRouteMenu ? dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: false }) : dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: true })}>
                            <FontAwesomeIcon icon={['fas', 'bars']} size="lg" style={{ fontSize: 20 }} />
                        </button>
                        <a href={config.RootUrl + '/modules/myworkspace/#/'}>
                            <p className="college text-white">{ReactHtmlParser(config.institute_name)}</p>
                        </a>
                    </div>
                    <div className="user-info">
                       {/*  <span className="dropdown mr-4">
                            <FontAwesomeIcon style={{ color: 'white', marginLeft: 10, cursor:'pointer', fontSize: 18 }} size="xl" icon={['fas', 'th']} data-toggle="dropdown" />
                            <div className="dropDownDiv dropdown-menu moduleListMenu mt-2" id="moduleDropdown" aria-labelledby="dropdownMenuButton" onClick={(e) => e.stopPropagation()} style={{ left: '-57vw', width: '60vw', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} >
                                <div className='row col-md-12 d-flex flex-column'>
                                    <div className='col-md-12 moduleListHeaderDetails row' style={{ padding: 0 }}>
                                        <div className='col-md-4' style={{ padding: 0 }}>
                                            <h4>Modules</h4>
                                        </div>
                                        <div className='col-md-6 mblScreen align-items-center' style={{ padding: 0 }}>
                                            <input
                                                className="form-control mr-sm-2 searchModuleInput"
                                                type="search"
                                                placeholder="Search"
                                                aria-label="Search"
                                                onChange={(e) => setSearchModule(e.target.value.toLowerCase())}
                                            />
                                            <span className="dropdown">
                                                <p className="filterModuleButton" data-toggle="dropdown" onClick={() => setShowFilter(!showFilter)}>
                                                    <FontAwesomeIcon icon={['fas', 'filter']} style={{ marginRight: 5 }} />
                                                    Filter
                                                </p>
                                                <div className={showFilter ? "dropDownFilter dropdown-menu moduleTypeMenu show" : " dropdown-menu deleteMenu"} style={{ left: '-31vh', borderRadius: 5 }} aria-labelledby="dropdownMenuButton" onClick={(e) => e.stopPropagation()}>
                                                    <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                        <input
                                                            className='mr-2'
                                                            type="checkbox"
                                                            onChange={(e) => handleFilterByCategory(e)}
                                                            value="OBE (Outcome Based Education)"
                                                            id="0"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <p className='filterName' > OBE (Outcome Based Education)</p>
                                                    </span>
                                                    <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                        <input
                                                            className='mr-2'
                                                            type="checkbox"
                                                            onChange={(e) => handleFilterByCategory(e)}
                                                            value="ERP (Enterprise Resource Planning)"
                                                            id="1"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <p className='filterName' > ERP (Enterprise Resource Planning)</p>
                                                    </span>
                                                    <span className="dropdown-item d-flex align-items-center" style={{ padding: '5px 10px' }}>
                                                        <input
                                                            className='mr-2'
                                                            type="checkbox"
                                                            onChange={(e) => handleFilterByCategory(e)}
                                                            value="Teaching & Learning"
                                                            id="2"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <p className='filterName' > Teaching & Learning</p>
                                                    </span>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="dropdown-divider"></div>
                                    <div className='row customScrollDiv' style={{ maxHeight: '46vh', overflowY: 'scroll' }} >
                                        {
                                            moduleListArray.filter((moduleName) =>
                                                moduleName.title.toLowerCase().includes(searchModule)).length == 0 ?
                                                    <p style={{ fontSize: 14, color: '#818181' }}>Any result is not available as per your applied filter. Please alter your selection text.</p>
                                                :
                                                moduleListArray.filter((moduleName) =>
                                                    moduleName.title.toLowerCase().includes(searchModule)).map((item) => {
                                                        return (
                                                            <a className='moduleItems col-md-4 col-sm-12' href={`${config.RootUrl}${item.url}`} style={{ textDecoration: 'none' }}>
                                                                <div className='moduleListIcon'>
                                                                    <FontAwesomeIcon href={`${config.RootUrl}${item.url}`} color="black" icon={[`${item.iconType}`, `${item.iconName}`]} />
                                                                </div>
                                                                <b className='menuText titleName'>{item.title}</b>
                                                            </a>

                                                        )
                                                    })
                                        }
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span className="award-points">
                            <span className="awards badge-pill" style={{ display: "inline-flex", paddingTop: 0, alignItems: "center" }}>
                                {pointsData}<FontAwesomeIcon className="award-icon" icon={['fas', 'trophy']} size="lg" color="#FF9900" />
                            </span>
                        </span>
                        <div className="streams-user-info">
                            <span className="dropdown mr-4">
                                {
                                    imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                        <img src={config.userPic} className="admin" data-toggle="dropdown" style={{ cursor: 'pointer' }} />
                                    :
                                        <FontAwesomeIcon
                                            icon={['fas', 'user-circle']}
                                            size="lg"
                                            style={{ fontSize: 30, cursor: 'pointer' }}
                                            color="#fff"
                                            data-toggle="dropdown"
                                        />
                                }
                                <div className="dropDownDiv dropdown-menu userDetailsMenu mt-2" id="moduleDropdown" aria-labelledby="dropdownMenuButton" onClick={(e) => e.stopPropagation()} style={{ left: '-17vw', width: '20vw', borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px' }} >
                                    <div className="userName-Image">
                                        {
                                            imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                                <img src={config.userPic} className="admin" data-toggle="dropdown" />
                                            :
                                                <FontAwesomeIcon
                                                    icon={['fas', 'user-circle']}
                                                    size="lg"
                                                    style={{ fontSize: 30 }}
                                                    color="#000"
                                                    data-toggle="dropdown"
                                                />
                                        }
                                        <p style={{ fontSize: 14, fontWeight: 'bold' }}>{config.instructorInfo.FirstName} {config.instructorInfo.LastName}</p>
                                    </div>
                                    <hr />
                                    <div className="userEmailId">
                                        <FontAwesomeIcon icon={['far', 'envelope']} style={{ width: 20, fontSize: 18 }} />
                                        <p style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis' }} title={config.emailId}>{config.emailId}</p>
                                    </div>
                                    <div className="userAccessId">
                                        <FontAwesomeIcon icon={['far', 'id-badge']} style={{ width: 20, fontSize: 18 }} />
                                        <p style={{ fontSize: 14 }}>{config.instructorInfo.user_id}</p>
                                    </div>
                                    <hr />
                                    <div className="updateProfileContainer">
                                          <a className="updateProfileLink" href={config.RootUrl + "/modules/personalise/#"}>
                                                <p className="updateProfileButton" title="Click to update profile details">
                                                    Update Profile
                                                </p>
                                            </a>
                                    </div>
                                </div>
                            </span>
                            <a href={`${config.RootUrl}/vmlogout.php?url=${config.instructorInfo.InstituteUrl}`} className="signout" onClick={() => userSignOut()}><FontAwesomeIcon className="signout-icon icon" icon={['fas', 'power-off']} size="lg" />Sign Out</a>
                        </div>*/}
                        <div className='workspaceHeader mt-1' style={{ color: '#FFFFFF', cursor: 'pointer', flexWrap: "nowrap" }}>
                            <span className={`dropdown mr-2 header-icon-bg ${userInfoModal ? 'ws-vm-header-icon-bg-color' : ''}`} style={{ borderRadius: '20px', padding: '2px' }}>
                                <div
                                    style={{ display: 'flex', padding: '6px 10px 6px 4px', flexDirection: 'row', gap: '8px', height: '30px', border: '1px solid #18191B', borderRadius: '20px', backgroundColor: '#FFFFFF', color: '#000000', alignItems: 'center' }}
                                    onClick={() => handleModalOpenClose('userInfo')}>
                                    {
                                        imageExtensions.includes(config.userPic.substring(config.userPic.lastIndexOf('.') + 1)) ?
                                            <img alt='config.userPic' src={config.userPic} className="admin" style={{ cursor: 'pointer', height: '20px', width: '20px' }}

                                            />
                                            :
                                            <FontAwesomeIcon
                                                icon={['fas', 'user-circle']}
                                                size="lg"
                                                className='ws-lock-subscription-color'
                                                style={{ fontSize: 30, height: '20px', width: '20px', cursor: 'pointer' }}

                                            />
                                    }
                                    <span
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            cursor: 'pointer',
                                            padding: '3px',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <p className='vm_custom_body18' style={{ margin: 0, padding: 0 }}>{pointsData}</p>
                                        <p className='vm_custom_body17' style={{ margin: 0, padding: 0 }}>Points</p>
                                    </span>
                                </div>
                            </span>
                            <span className="vl"></span>
                            <div
                                className={`d-flex align-items-center justify-content-center cursor-pointer rounded p-1 header-icon-bg mr-2 ${openBookMarkModal ? "ws-vm-header-icon-bg-color" : ""
                                    }`}
                                onClick={() => handleModalOpenClose("bookmarkModal")}
                                style={{ position: "relative" }}
                            >
                                <Grip size={18} color="white" />
                            </div>
                        </div>
                        <div onClick={() => handleModalOpenClose('userActivity')} className='header-icon-bg mobileViewUserActivity mr-2' style={{ position: "relative", borderRadius: '8px', padding: '4px' }}>
                            <History size={18} color="white" className='cursor-pointer' />
                        </div> 
                        <div onClick={() => {
                            handleModalOpenClose('notification');
                        }} className='header-icon-bg mobileViewNotificationActivity mr-2' style={{ position: "relative", borderRadius: '8px', padding: '4px' }}>
                            {

                                <span
                                    className="position-absolute d-flex justify-content-center align-items-center shadow-sm "
                                    style={{ borderRadius: '50%', width: '18px', height: '18px', top: '-5px', left: '10px', fontSize: '10px', backgroundColor: '#ff0000', color: 'white' }}
                                >
                                    {
                                        (Number(unReadMessageCount) + Number(unReadUpdateReadMessageCount)) < 99 ? (Number(unReadMessageCount) + Number(unReadUpdateReadMessageCount)) : "99+"
                                    }

                                </span>
                            }
                            <Bell size={18} fill="#FFFFFF" color="white" className='cursor-pointer' />
                        </div>          
                    </div>
                </nav>
            </div>
            {
                (stepNumber >=1 || acceptanceCount > 1 ) &&
                    <div className = "subscriptionStrip" style={{ backgroundColor: (stepNumber >1 || acceptanceCount > 1) ? '#EB5757' : stepNumber == 1 ? '#FF7800' : 'transparent', paddingTop: !(stepNumber >=1 || acceptanceCount > 1 )  ? 50 : 5, paddingBottom: !(stepNumber >=1 || acceptanceCount > 1 ) ? 0 : 2, height: !(stepNumber >=1 || acceptanceCount > 1 ) ? 0 : 'auto', zIndex: !(stepNumber >=1 || acceptanceCount > 1 ) ? -1 : 19 }}>{overdueMessage}</div>
            }
            <SideNav />
            {
                returnSubscriptionAlertModal()
            }
            {openBookMarkModal && <BookMarkModal openBookMarkModal={openBookMarkModal} handleClose={() => closeBookMark()} />}
            {
                ActivityLogModal && <UserActivityPanel ActivityLogModal={ActivityLogModal} handleModalOpenClose={handleModalOpenClose} instituteIdArray={instituteIdArray} />
            }
            {
                notificationModal && <NotificationPanel notificationUpdates={notificationUpdates} notificationModal={notificationModal} handleModalOpenClose={handleModalOpenClose} instituteIdArray={instituteIdArray}/>
            }
            {
                userInfoModal && <UserProfilePanel userInfoModal={userInfoModal} handleModalOpenClose={handleModalOpenClose} />
            }
            {
                successModal &&
                    <SuccessModal 
                        successModal={successModal} 
                        successModalType={successModalType}
                        successMessage={successMessage}
                        closeSuccessModal={setSuccessModal(false)} 
                    />
            }
        </>
    );
}

export default Header;